import getFromCdn from '@anm/helpers/getFromCdn';
import { flexCenter } from '@anm/styles/helpers';
import { FC } from 'react';
import styled from 'styled-components';

type DotsCardNumberProps = {
  last4: string;
};

const CardDots = styled.div`
  background-image: url(${getFromCdn(`images/icons/card-dots.svg`)});
  display: inline-block;
  width: 100%;
  max-width: 131px;
  height: 4px;
  margin-right: 19px;
`;

export const CardNumberWrapper = styled.div`
  ${flexCenter};
  width: 100%;
`;
const DotsCardNumber: FC<DotsCardNumberProps> = ({ last4 }) => (
  <CardNumberWrapper>
    <CardDots />
    <span>{last4}</span>
  </CardNumberWrapper>
);

export default DotsCardNumber;
